let $productData;

function loadProducts($destination) {
    $productData = $destination.find('.js-product-data');
    $.ajax({
        url: linku_ajax_url,
        type: 'post',
        data: {
            action: 'load_products',
            shipment_type: $productData.data('shipment_type'),
            destination_id: $productData.data('destination_id'),
            products: $productData.data('products'),
            smp: $productData.data('smp') ? $productData.data('smp') : false,
        },
        dataType: 'json',
        success: function (response) {
            $productData.replaceWith(response.html);
            initSlider();
        },
        error: function (response) {
            console.log('error', response);
        }
    });
}
